import { Checkbox, FieldError } from "@scribenote/brian-design-system";
import { useClinicRoles } from "@users/rolesQueries";

/** The clinic's roles as checkboxes. `roleIds` keeps the order roles were
 * ticked in; brian treats the first as the primary role. `locked` roles can't
 * be changed here. */
export const RoleFieldset = ({
  sessionKey,
  roleIds,
  onChange,
  disabled,
  testIdPrefix,
  locked = [],
}: {
  sessionKey: string;
  roleIds: string[];
  onChange: (roleIds: string[]) => void;
  disabled: boolean;
  testIdPrefix: string;
  locked?: string[];
}) => {
  const roles = useClinicRoles(sessionKey);

  const toggle = (roleId: string, checked: boolean) =>
    onChange(
      checked ? [...roleIds, roleId] : roleIds.filter((id) => id !== roleId),
    );

  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="mb-1.5 font-body text-sm font-medium text-ink">
        Roles
      </legend>
      {roles.data?.map((role) => (
        <Checkbox
          key={role.id}
          label={roleIds[0] === role.id ? `${role.name} (primary)` : role.name}
          checked={roleIds.includes(role.id)}
          onChange={(e) => toggle(role.id, e.target.checked)}
          disabled={disabled || locked.includes(role.id)}
          data-testid={`${testIdPrefix}-${role.id}`}
        />
      ))}
      {roles.isError && (
        <FieldError>Couldn’t load the clinic’s roles. Try again.</FieldError>
      )}
    </fieldset>
  );
};
